import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";

export const theme: BaseTheme = { ...baseTheme };
